export default Array(30)
  .fill()
  .map((element, index) =>
    index + 1 < 10 ? `0${index + 1}` : `${index + 1}`,
  );
